import { render, staticRenderFns } from "./overdue.vue?vue&type=template&id=bc582c54&scoped=true&"
import script from "./overdue.vue?vue&type=script&lang=js&"
export * from "./overdue.vue?vue&type=script&lang=js&"
import style0 from "./overdue.vue?vue&type=style&index=0&id=bc582c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc582c54",
  null
  
)

export default component.exports